import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/AuthContext';
import { Users } from 'lucide-react';

export const CommunityMinimal: React.FC = () => {
  console.log('🏘️ CommunityMinimal component rendered');
  
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    console.log('🏘️ CommunityMinimal useEffect triggered', { hasUser: !!user });
    
    // Simple timeout to prevent infinite loading
    const timeout = setTimeout(() => {
      console.log('⏰ CommunityMinimal timeout - setting loading to false');
      setLoading(false);
    }, 3000);

    // Simulate some work
    setTimeout(() => {
      console.log('🏘️ CommunityMinimal work complete');
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [user]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading Community...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-red-50 to-pink-50 flex items-center justify-center">
        <div className="text-center">
          <div className="bg-red-100 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto shadow-2xl mb-6">
            <Users className="w-10 h-10 text-red-600" />
          </div>
          <h2 className="text-2xl font-bold text-red-800 mb-4">Error Loading Community</h2>
          <p className="text-red-600 mb-6">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <div className="bg-gradient-to-br from-blue-400 to-purple-500 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto shadow-2xl mb-6">
            <Users className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Community</h1>
          <p className="text-gray-600 text-lg">Connect with fellow first responders</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Welcome to the Community!</h2>
          <p className="text-gray-600 mb-6">
            This is a minimal version of the Community page to test basic functionality.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-blue-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">Discover Groups</h3>
              <p className="text-blue-600">Find and join groups of fellow first responders</p>
            </div>
            
            <div className="bg-green-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-green-800 mb-2">My Groups</h3>
              <p className="text-green-600">Manage your group memberships and activities</p>
            </div>
            
            <div className="bg-purple-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-purple-800 mb-2">Connect</h3>
              <p className="text-purple-600">Build meaningful connections with your peers</p>
            </div>
          </div>

          {user && (
            <div className="mt-8 p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-600">
                Signed in as: <span className="font-semibold">{user.displayName || user.email}</span>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

















